import { render } from "./MandateAlreadyCompleted.vue?vue&type=template&id=2c1a0538&scoped=true"
import script from "./MandateAlreadyCompleted.vue?vue&type=script&lang=js"
export * from "./MandateAlreadyCompleted.vue?vue&type=script&lang=js"

import "./MandateAlreadyCompleted.vue?vue&type=style&index=0&id=2c1a0538&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1a0538"]])

export default __exports__